var render, staticRenderFns
import script from "./productLevel.vue?vue&type=script&lang=js&"
export * from "./productLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a10aac0')) {
      api.createRecord('1a10aac0', component.options)
    } else {
      api.reload('1a10aac0', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/terminal_audit/form/components/productLevel/productLevel.vue"
export default component.exports